import { FOLDER_TRASH_ID } from "@zapier/utils";
import { RouterOutputs, trpc } from "../trpc";

interface Input {
  folderId: string;
  hasError: boolean;
}

export type FolderDiscovery = RouterOutputs["folder"]["getFolderDiscovery"];

export function useQueryFolderDiscovery({ folderId, hasError }: Input) {
  const { data, isLoading } = trpc.folder.getFolderDiscovery.useQuery(
    {
      folderId,
    },
    {
      enabled: !!folderId && hasError && folderId !== FOLDER_TRASH_ID,
    },
  );

  return {
    accountInfo: data,
    isLoading,
  };
}
